export const LANGUAGE_CODES = {
  ENGLISH: "EN",
  ARABIC: "AR",
};

const normalizeBaseKey = (baseKey = "") =>
  baseKey.replace(/_(english|arabic|en|ar)$/i, "");

const buildKeyVariants = (baseKey = "", postfixes = []) =>
  postfixes.map((suffix) => `${baseKey}_${suffix}`);

const defaultFallbackKeys = (baseKey) => [
  `${baseKey}`,
  baseKey.toLowerCase(),
  baseKey.toUpperCase(),
];

export const getLocalizedFieldValue = (
  item = {},
  language = LANGUAGE_CODES.ENGLISH,
  baseKey = "",
  options = {}
) => {
  const {
    englishKeys = [],
    arabicKeys = [],
    fallbackKeys = [],
  } = options;

  if (!item || !baseKey) return "";

  const normalizedBase = normalizeBaseKey(baseKey);

  const englishVariants = [
    ...englishKeys,
    ...buildKeyVariants(normalizedBase, ["english", "en"]),
  ];
  const arabicVariants = [
    ...arabicKeys,
    ...buildKeyVariants(normalizedBase, ["arabic", "ar"]),
  ];
  const combinedFallbacks = [...fallbackKeys, ...defaultFallbackKeys(normalizedBase)];

  const keyPriority =
    language === LANGUAGE_CODES.ARABIC
      ? [...arabicVariants, ...combinedFallbacks]
      : [...englishVariants, ...combinedFallbacks];

  for (const key of keyPriority) {
    if (item?.[key] !== undefined && item?.[key] !== null && item?.[key] !== "") {
      return item[key];
    }
  }

  return "";
};

